import React from "react";
import { Breadcrumb } from "antd";

/**
 * Shared page header: optional breadcrumb, title, subtitle, and right-side actions.
 *
 * @param {{
 *   breadcrumb?: Array<{ title: React.ReactNode }>,
 *   title: React.ReactNode,
 *   subtitle?: React.ReactNode,
 *   actions?: React.ReactNode,
 *   className?: string,
 * }} props
 */
const PageHeader = ({
	breadcrumb,
	title,
	subtitle,
	actions,
	className = "",
}) => {
	return (
		<div className={`page-header ${className}`.trim()}>
			<div className="page-header__main">
				{breadcrumb && breadcrumb.length > 0 ? (
					<Breadcrumb
						className="page-header__breadcrumb"
						items={breadcrumb}
					/>
				) : null}
				<h1 className="page-header__title">{title}</h1>
				{subtitle ? (
					<p className="page-header__subtitle">{subtitle}</p>
				) : null}
			</div>
			{actions ? (
				<div className="page-header__actions">{actions}</div>
			) : null}
		</div>
	);
};

export default PageHeader;
